import styled from '@emotion/styled';
import React from 'react';

const Address = styled.address``;

const Location = ({ location }) => <Address>{location}</Address>;

export default Location;
